import Vue from 'vue'
import { IVueCookies } from '@/vendor/vue-cookies'

const BM_COOKIES = {
  UPDATE_FILL_IN_FILLGRID: 'update-fill-in-fillgrid'
}

class CookiesService implements IVueCookies {
  config (expireTimes: any, path?: string | undefined, domain?: string | undefined): void {
    Vue.prototype.$cookies.config(expireTimes, path, domain)
  }
  set (
    keyName: string,
    value: any,
    expireTimes?: any,
    path?: string | undefined,
    domain?: string | undefined,
    secure?: boolean | undefined
  ): IVueCookies {
    return Vue.prototype.$cookies.set(keyName, value, expireTimes, path, domain, secure)
  }
  get (keyName: string) {
    return Vue.prototype.$cookies.get(keyName)
  }
  remove (keyName: string, path?: string | undefined, domain?: string | undefined): IVueCookies {
    return Vue.prototype.$cookies.remove(keyName, path, domain)
  }
  isKey (keyName: string): boolean {
    return Vue.prototype.$cookies.isKey(keyName)
  }
  keys (): any[] {
    return Vue.prototype.$cookies.keys()
  }
}

export default new CookiesService()
export { BM_COOKIES }
